/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S2_Cancel_DescInputs */

const tr_iade_iptal_s2_cancel_desc = /** @type {(inputs: Iade_Iptal_S2_Cancel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abone'nin, hizmetin ödenen Abonelik Dönemi'nin sonunda sona ermesini istediğine ilişkin bildirimi; dönem sonuna kadar hizmet kullanımı devam eder. Abonelik otomatik olarak yenilenmediğinden İptal, dönem sonunda yeni bir satın alma yapılmayacağı anlamına gelir.`)
};

const en_iade_iptal_s2_cancel_desc = /** @type {(inputs: Iade_Iptal_S2_Cancel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Subscriber's notice that the service is to end at the end of the paid Subscription Period; use of the service continues until the end of the period. As the Subscription does not renew automatically, Cancellation means that no new purchase is made at the end of the period.`)
};

const de_iade_iptal_s2_cancel_desc = /** @type {(inputs: Iade_Iptal_S2_Cancel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Mitteilung des Abonnenten, dass der Dienst zum Ende des bezahlten Abonnementzeitraums enden soll; bis zum Ende des Zeitraums läuft die Nutzung weiter. Da sich das Abonnement nicht automatisch verlängert, bedeutet die Kündigung, dass zum Ende des Zeitraums kein neuer Kauf erfolgt.`)
};

const ru_iade_iptal_s2_cancel_desc = /** @type {(inputs: Iade_Iptal_S2_Cancel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомление Абонента о том, что услуга должна прекратиться по окончании оплаченного Периода подписки; до конца периода использование услуги продолжается. Поскольку Подписка не продлевается автоматически, Отмена означает, что по окончании периода новая покупка не совершается.`)
};

/**
* | output |
* | --- |
* | "The Subscriber's notice that the service is to end at the end of the paid Subscription Period; use of the service continues until the end of the period. As t..." |
*
* @param {Iade_Iptal_S2_Cancel_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s2_cancel_desc = /** @type {((inputs?: Iade_Iptal_S2_Cancel_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S2_Cancel_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s2_cancel_desc(inputs)
	if (locale === "de") return de_iade_iptal_s2_cancel_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s2_cancel_desc(inputs)
	return tr_iade_iptal_s2_cancel_desc(inputs)
});